var map = {
	"./en-CA/index.js": [
		1236,
		1
	],
	"./fr-FR/index.js": [
		1237,
		2
	],
	"./it-IT/index.js": [
		1238,
		1,
		2,
		0,
		42
	],
	"./nl-BE/index.js": [
		1239,
		0,
		43
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 547;
module.exports = webpackAsyncContext;